import React, { useEffect, useState } from "react";
import Styles from "./myDownloadStyles.module.css";
import { Table, Tag, Button, Spin, Popover , Tooltip} from "antd";
import { DownloadOutlined, ReloadOutlined} from "@ant-design/icons";
import { fetchRfpUpload , getFilesRFP} from "../../API/api";
import {ReactComponent as DownIcon} from '../../Icons/downIcon.svg';

export default function MyDownload() {
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState('');
    const [isLoading, setLoading] = useState(false);
  const fetchDocuments = () => {
    setLoading(true);
    fetchRfpUpload().then((res) => {
      if (res===undefined) return;
      if (res.data.success) {
        setData(res.data.data);
        setLoading(false);
      }
    });
  };
  const showRoutingHistoryDate = (start)=>{
    let newDate = `${new Date(start).getFullYear()}-${new Date(start).getMonth()+1>9?new Date(start).getMonth()+1:new Date(start).getMonth()+1}-${new Date(start).getDate()}`;
  return `${newDate} ${new Date(start).getHours().toString().length >1 ? new Date(start).getHours():'0'+new Date(start).getHours()}:${new Date(start).getMinutes().toString().length >1 ? new Date(start).getMinutes():'0'+new Date(start).getMinutes()}`;
}
  const headTitle = (text) => {
    if(text==='Download'){
      return (
        <>
          <div onClick={()=>setRefresh(Math.random()*10)} style={{ fontSize: "15px", fontWeight: "500", textAlign:'center', cursor:'pointer', color:'#5D6676' }}><ReloadOutlined /></div>
        </>
      );
    }else{
      return (
        <>
          <span style={{ fontSize: "15px", fontWeight: "400", color:'#5D6676' }}>{text}</span>
        </>
      );
    }
  };
  const columns = [
    {
      title: headTitle("File Name"),
      dataIndex: "name",
      key: "name",
      //   width:'28%',
      sort: true,
      render: (_, raw) => {
        return (
          <>
            <span
              style={{ fontSize: "14px", fontWeight: "300", wordBreak: 'break-word',overflowWrap: 'break-word', color:'#2A364A'}}
            >
              {raw.docName}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Date"),
      dataIndex: "age",
      key: "age",
      width:'15%',
      render: (_, raw) => {
        return (
          <>
            <span
              style={{ fontSize: "14px", fontWeight: "300" , color:'#2A364A' }}
            >
              {showRoutingHistoryDate(raw.submissionDate)}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Domain"),
      dataIndex: "age",
      key: "age",
      // width:'22%',
      render: (_, raw) => {
        const content =()=>{
          return(
            (
              <div>
              {raw.domains.map(domain=>{
                return(
                    <Tag color="var(--light_color_shade)" style={{color:'#fff',fontSize:'12px'}}>{domain}</Tag>
                )
              })}
              </div>
            )
          )
        }
        return (
          <>
            {raw.domains.length === 0 ? (
              <span style={{ color: "lightgrey" }}>---</span>
            ) : (
              <>
              <Tooltip color="#fff" content={content} placement="bottom" title={content} style={{width:'400px'}}>
              <Tag color="var(--light_color_shade)" style={{color:'#fff'}}>{raw.domain === null ? "" : raw.domains[0]}</Tag>
              </Tooltip>
              {raw.domains.length > 1 &&<span style={{fontSize:'12px', color:'#2A364A', fontWeight:'300', marginLeft:'-5px'}}>+{raw.domains.length-1} more</span>}
              </>
            )}
          </>
        );
      },
    },
    {
      title: headTitle("Language"),
      dataIndex: "address",
      key: "address",
      //   width:'18%',
      render: (_, raw) => {
        return (
          <>
            <span
              style={{ fontSize: "14px", fontWeight: "300", color:'#2A364A'}}
            >
              {raw.alternateLanguage}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Type"),
      dataIndex: "address",
      key: "address",
      // width:'10%',
      render: (_, raw) => {
        return (
          <>
            <span
              style={{ fontSize: "14px", color:'#2A364A', fontWeight: "300"}}
            >
              {raw.outputType}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Download"),
      dataIndex: "address",
      key: "address",
      width: "7%",
      render: (_, raw) => {
        const onClickDownload = () =>{
            let arr = [raw.outputDocName];
            getFilesRFP(arr).then(res=>{
              if (res===undefined) return;
                window.open(res.data.data[raw.outputDocName], '_blank');
            })
        }
        return (
          <div style={{ textAlign: "center" }}>
            <DownIcon style={{cursor:'pointer'}} onClick={()=>onClickDownload()}/>
            {/* <Button shape="circle" type="dashed" icon={<DownloadOutlined  />} onClick={()=>onClickDownload()} /> */}
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    fetchDocuments();
  }, [refresh]);
  return (
    <>
      <Spin spinning={isLoading}>
      <Table
        // rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
        columns={columns}
        pagination={false}
        dataSource={data}
        style={{ boxShadow: "7px 7px 20px lightgrey", borderRadius:'20px' }}
      />
      </Spin>
    </>
  );
}
